import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { UpdateTeamRequest, UpdateTeamResponse, API_QUERY_KEYS, updateTeam } from 'api';

export const useUpdateTeam = (): UseMutationResult<
  UpdateTeamResponse,
  unknown,
  UpdateTeamRequest
> => {
  const queryClient = useQueryClient();
  return useMutation(updateTeam, {
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: [API_QUERY_KEYS.getManageTeamConsultees] });
      queryClient.invalidateQueries({ queryKey: [API_QUERY_KEYS.getTeams] });
      queryClient.invalidateQueries({ queryKey: [API_QUERY_KEYS.getAllTeams] });
    },
  });
};
